import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'sonner';
import { LandingCarrusel } from '@/components/LandingCarrusel';
import { LandingMenu } from '@/components/LandingMenu';
import { LandingTestimonios } from '@/components/LandingTestimonios';

const API = process.env.REACT_APP_BACKEND_URL;
const WA = '50254307807';
const AZUL = '#1FA3E8';
const A = 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts';
const S = 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images';

const IMG = {
  logo: `${A}/ckf7btpo_c3217efc-1851-4a8d-8daf-e535de3c5dd6.jpeg`,
  hero: `${A}/lkoq46hn_270d70bc-b4d7-4436-aa20-273deb8d2a81.jpeg`,
  corredizaBlanca: `${A}/lb5xgj56_9a84a3b5-2d62-444f-9e2b-a746aa3143a8.jpeg`,
  abatiblesOscuras: `${A}/95pjoiwt_e113f7f9-cccd-42c6-a676-04b7af73f85b.jpeg`,
  ventanaCorrediza: `${A}/t3i860o7_75ba5ff3-1ca9-456d-a76b-81183d11b79c.jpeg`,
  ventanaFija: `${A}/iodf6tql_18b7e02e-ab48-4d8d-841d-280f8db182a2.jpeg`,
  abatibleBlanca: `${S}/b23e8e59e0e84e5fdca3d323e0be41f2405ba36f19d58544b5c97b26db758c15.jpeg`,
  proyectable: `${A}/lb8dgj1b_08080ed6-1ff4-4672-a891-baf1997b3e2f.jpeg`,
  guillotina: `${S}/fc8415ce43cbbd9e59a81c2b5c17b8533311101fcc7eedc408d200b274511ca3.jpeg`,
  casaBlanca: `${A}/9eby1mop_32daef5d-cf05-472d-b369-cb3aeb1a29ef.jpeg`,
  maderaClaro: `${A}/9a6z85mm_dba4c33b-e0ac-4e2c-a13d-3bce37adf611.jpeg`,
  maderaOscuro: `${A}/zp95b27t_625ff537-3f0c-4df5-b7fa-e3f507de11a2.jpeg`,
  cedazo: `${A}/zp95b27t_625ff537-3f0c-4df5-b7fa-e3f507de11a2.jpeg`,
  corredizaV2: `${S}/0d0de6a70014be70034d07e61ea0850c9dd3b8c25dd532100ce5cbdf8db76750.jpeg`,
  abatibleV2: `${S}/f0ab781b85c875912e39b11bd43768c27087466b5683c6bc7c124b9f5e743635.jpeg`,
  maderaClaraV2: `${S}/d30a2242ccfcc6e477d4712ba05dbebf33c1c0938e98d5be252189f6a994b5a5.jpeg`,
  maderaOscuraV2: `${S}/f17f6820dbaa0fdac7aa2e416b575ecb10298ae0aeed1d871f8246767b439cb1.jpeg`,
  vidrioInsulado: `${S}/d3d5d02a46ab16f77b8295c775b15883d34ae1b431ac54234ca0b239c857225d.jpeg`,
  banner: `${A}/uqxfvluf_b3888574-78f3-4db0-9a88-d1141f500994.jpeg`,
};

const CARRUSEL_INICIAL = [
  { url: IMG.hero, caption: 'Ventanales fijos de PVC en residencia moderna' },
  { url: IMG.corredizaBlanca, caption: 'Puerta corrediza blanca con vidrio bronce' },
  { url: IMG.maderaOscuro, caption: 'Corrediza imitación madera con cedazo' },
  { url: IMG.casaBlanca, caption: 'Ventanas corredizas blancas' },
  { url: IMG.ventanaCorrediza, caption: 'Ventana corrediza en fachada de piedra' },
];

const DEPARTAMENTOS = ['Guatemala', 'Sacatepéquez', 'Chimaltenango', 'Escuintla', 'Santa Rosa', 'Sololá', 'Totonicapán', 'Quetzaltenango', 'Suchitepéquez', 'Retalhuleu', 'San Marcos', 'Huehuetenango', 'Quiché', 'Baja Verapaz', 'Alta Verapaz', 'Petén', 'Izabal', 'Zacapa', 'Chiquimula', 'Jalapa', 'Jutiapa', 'El Progreso'];

const waLink = (text) => `https://wa.me/${WA}?text=${encodeURIComponent(text)}`;

const RAZONES = [
  ['Máximo confort con vidrio insulado', 'Combina tus ventanas con vidrio insulado termoacústico (doble vidrio con cámara sellada) y logra el máximo aislamiento contra el calor y el ruido.'],
  ['Cierre hermético', 'Los perfiles multicámara y empaques del PVC sellan tu casa contra filtraciones de aire, polvo y agua de lluvia.'],
  ['Cero mantenimiento', 'No se oxida, no se despinta ni se deforma. Solo necesita agua y jabón neutro de vez en cuando para lucir como nuevo por décadas.'],
  ['Calidad con respaldo', 'PVC importado de buena calidad, fabricado e instalado bajo los estándares de calidad, servicio y garantía de Soluciones Arquitectónicas.'],
];

const VENTANAS = [
  ['Corrediza', 'Las hojas se deslizan a los lados. La favorita para dormitorios y salas.', 'ventanaCorrediza'],
  ['Fija', 'Paneles que no abren: máxima luz y vista panorámica.', 'ventanaFija'],
  ['Abatible', 'Abre hacia adentro o afuera como una puerta. Ventilación total.', 'abatibleBlanca'],
  ['Proyectable', 'Abre hacia afuera desde la base: ventila incluso con lluvia.', 'proyectable'],
  ['Tipo guillotina', 'La hoja sube y baja verticalmente. Estilo clásico y funcional.', 'guillotina'],
];

const COLORES = [
  ['Blanco', 'casaBlanca'],
  ['Imitación madera claro', 'cedazo'],
  ['Imitación madera oscuro', 'maderaOscuraV2'],
];

export default function LandingPVC() {
  const [form, setForm] = useState({ nombre: '', telefono: '', departamento: '', detalles: '' });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    axios.post(`${API}/api/landing/track`, { producto: 'pvc_puertas_ventanas' }).catch(() => {});
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim() || !form.telefono.trim() || !form.departamento) {
      toast.error('Completa tu nombre, teléfono y departamento');
      return;
    }
    try {
      setSending(true);
      const res = await axios.post(`${API}/api/landing/pvc/lead`, form);
      setDone(res.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Error enviando, intenta de nuevo');
    } finally { setSending(false); }
  };

  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif" }} className="min-h-screen bg-[#080B10] text-white">
      <Toaster position="top-center" richColors />
      <style>{`@keyframes deslizarX{0%,100%{transform:translateX(0)}50%{transform:translateX(10px)}}`}</style>

      <header className="sticky top-0 z-40 bg-[#080B10]/90 backdrop-blur border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={IMG.logo} alt="Soluciones Arquitectónicas" className="h-10 sm:h-11 w-auto rounded" data-testid="header-logo" />
            <p className="hidden sm:block text-[10px] text-white/50 tracking-[0.25em] uppercase border-l border-white/15 pl-3">Modernizando ambientes</p>
          </div>
          <div className="flex items-center gap-2">
            <LandingMenu actual="/pvcpuertasyventanas" />
            <a href={waLink('¡Hola! Vi la página de puertas y ventanas de PVC y quiero una cotización 😊')}
              target="_blank" rel="noreferrer" data-testid="wa-header-btn"
              className="bg-[#25D366] hover:brightness-110 text-white text-sm font-bold px-4 py-2 rounded-full transition-all">
              WhatsApp
            </a>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative">
        <img src={IMG.hero} alt="Puertas y ventanas de PVC" className="w-full h-[64vh] object-cover object-center opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#080B10] via-[#080B10]/45 to-[#080B10]/25" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-6xl mx-auto px-4 pb-10 w-full">
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Nueva línea · Confort y silencio</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] max-w-3xl">
              Puertas y Ventanas <span style={{ color: AZUL }}>de PVC</span>
            </h1>
            <p className="text-white/70 text-base mt-4 max-w-xl">
              PVC importado de buena calidad, con los estándares de calidad, servicio y garantía de Soluciones Arquitectónicas. No se oxida, no necesita pintura y con vidrio insulado termoacústico logra el máximo aislamiento de calor y ruido.
            </p>
            <div className="flex gap-3 mt-6 flex-wrap">
              <a href="#cotizar" data-testid="hero-cta"
                style={{ background: AZUL }}
                className="hover:brightness-110 text-white font-black px-6 py-3 rounded-full text-sm transition-all">
                COTIZA GRATIS →
              </a>
              <a href={waLink('¡Hola! Quiero cotizar puertas o ventanas de PVC 😊')} target="_blank" rel="noreferrer"
                className="border border-white/25 hover:border-white/60 text-white font-bold px-6 py-3 rounded-full text-sm transition-colors">
                Escríbenos por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats strip */}
      <section style={{ background: AZUL }} data-testid="stats-strip">
        <div className="max-w-6xl mx-auto px-4 py-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          {[
            ['3 colores', 'blanco, madera claro y madera oscuro'],
            ['5 tipos', 'de ventanas + puertas corredizas y abatibles'],
            ['Cierre hermético', 'perfiles multicámara con empaques sellados'],
            ['+18 años', 'de experiencia instalando'],
          ].map(([n, t]) => (
            <div key={n}>
              <p className="text-2xl sm:text-3xl font-black leading-none">{n}</p>
              <p className="text-white/90 text-xs sm:text-sm font-medium mt-1">{t}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Por qué PVC */}
      <section className="max-w-6xl mx-auto px-4 py-14" data-testid="seccion-porque">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
          <div className="lg:col-span-2 lg:sticky lg:top-24">
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">El material inteligente</p>
            <h2 className="text-2xl sm:text-3xl font-black leading-tight">¿Por qué elegir <span style={{ color: AZUL }}>PVC</span>?</h2>
            <p className="text-white/60 text-base mt-4">
              El PVC es el material más usado en ventanería en Europa y Norteamérica por una razón: dura décadas, casi no pide cuidados y luce impecable. Ahora lo traemos a Guatemala con el respaldo de Soluciones.
            </p>
            <a href="#cotizar" style={{ background: AZUL }}
              className="inline-block mt-6 hover:brightness-110 text-white font-black px-6 py-3 rounded-full text-sm transition-all">
              QUIERO COTIZAR →
            </a>
          </div>
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {RAZONES.map(([t, d], i) => (
              <div key={t} className="bg-white/[0.04] border border-white/10 rounded-2xl p-5 hover:border-[#1FA3E8]/40 transition-colors" data-testid={`razon-${i}`}>
                <p style={{ color: AZUL }} className="text-2xl font-black leading-none mb-2">{String(i + 1).padStart(2, '0')}</p>
                <p className="font-black text-sm sm:text-base">{t}</p>
                <p className="text-white/55 text-sm mt-2 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Puertas */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-puertas">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Puertas de PVC</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Corredizas y <span style={{ color: AZUL }}>abatibles</span></h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {[
            ['Puertas corredizas', 'Se deslizan suavemente sin ocupar espacio. Perfectas para salidas a jardín, terraza o balcón.', IMG.corredizaV2],
            ['Puertas abatibles', 'Abren como puerta tradicional, con cierre hermético multipunto. Para entradas principales e interiores.', IMG.abatibleV2],
          ].map(([t, d, src]) => (
            <figure key={t} className="rounded-3xl overflow-hidden border border-white/10 bg-white/[0.03] group" data-testid={`puerta-${t.split(' ')[1]}`}>
              <img src={src} alt={t} className="w-full h-72 object-contain bg-black/40 group-hover:scale-105 transition-transform duration-500" />
              <figcaption className="p-5">
                <p className="font-black text-base">{t}</p>
                <p className="text-white/55 text-sm mt-1.5">{d}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* Ventanas */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-ventanas">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Ventanas de PVC</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">5 tipos para <span style={{ color: AZUL }}>cada ambiente</span></h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {VENTANAS.map(([t, d, img], i) => (
            <figure key={t} className={`rounded-2xl overflow-hidden border border-white/10 bg-white/[0.03] ${i === 4 ? 'col-span-2 md:col-span-1' : ''}`} data-testid={`ventana-${i}`}>
              <img src={IMG[img]} alt={`Ventana ${t} de PVC`} className="w-full h-40 object-cover object-center" />
              <figcaption className="p-3.5">
                <p className="font-black text-sm">{t}</p>
                <p className="text-white/50 text-xs mt-1 leading-relaxed">{d}</p>
              </figcaption>
            </figure>
          ))}
        </div>
        <p className="text-center text-white/55 text-sm mt-6" data-testid="cedazo-nota">
          🦟 Todas las puertas y ventanas pueden llevar <span className="text-white font-bold">cedazo (mosquitero)</span> fijo, corredizo o abatible.
        </p>
      </section>

      {/* Colores */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-colores">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Personaliza tu proyecto</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Colores <span style={{ color: AZUL }}>disponibles</span></h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {COLORES.map(([nombre, img]) => (
            <figure key={nombre} className="rounded-2xl overflow-hidden border border-white/10 group" data-testid={`color-${nombre.toLowerCase().replace(/ /g, '-')}`}>
              <img src={IMG[img]} alt={`PVC color ${nombre}`} className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-500" />
              <figcaption className="text-sm text-white/85 text-center font-bold px-2 py-3 bg-white/[0.05]">{nombre}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* Vidrios */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-vidrios">
        <div className="bg-white/[0.04] border border-white/10 rounded-3xl p-6 sm:p-8 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Combínalo a tu gusto</p>
            <h2 className="text-2xl sm:text-3xl font-black leading-tight">Elige tu <span style={{ color: AZUL }}>vidrio</span></h2>
            <div className="grid grid-cols-2 gap-2 mt-5 text-sm font-bold text-white/75">
              {['Vidrio claro', 'Vidrio bronce', 'Vidrio gris', 'Reflectivo (bajo pedido)'].map((v) => (
                <p key={v} className="flex items-center gap-2"><span style={{ color: AZUL }} className="font-black">✓</span>{v}</p>
              ))}
            </div>
            <div className="mt-5 border border-[#1FA3E8]/40 bg-[#1FA3E8]/10 rounded-2xl p-4" data-testid="vidrio-termoacustico">
              <p className="font-black text-sm" style={{ color: AZUL }}>⭐ Vidrio insulado termoacústico</p>
              <p className="text-white/65 text-sm mt-1.5">
                Doble vidrio con cámara de aire sellada: el máximo aislamiento contra el calor y el ruido. Disponible para PVC y también para nuestra Línea Euro de aluminio.
              </p>
            </div>
          </div>
          <figure className="rounded-2xl overflow-hidden border border-white/10 bg-white">
            <img src={IMG.vidrioInsulado} alt="Vidrio insulado termoacústico y muestras de vidrio claro, bronce y gris" className="w-full h-[360px] object-cover object-center" />
            <figcaption className="bg-black/60 text-xs text-white/70 px-4 py-2 font-bold">Vidrio insulado (doble vidrio con cámara) y muestras: claro, bronce y gris</figcaption>
          </figure>
        </div>
      </section>

      {/* Carrusel */}
      <section className="pb-14" data-testid="carrusel-proyectos">
        <div className="max-w-6xl mx-auto px-4 flex items-end justify-between gap-4">
          <div>
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2">Proyectos reales</p>
            <h2 className="text-2xl sm:text-3xl font-black mb-6">Inspírate para tu <span style={{ color: AZUL }}>proyecto</span></h2>
          </div>
          <p className="text-white/60 text-sm font-bold mb-6 shrink-0 flex items-center gap-1" data-testid="deslizar-hint">
            Deslizar <span style={{ color: AZUL, animation: 'deslizarX 1.2s ease-in-out infinite', display: 'inline-block' }} className="font-black text-lg">→</span>
          </p>
        </div>
        <LandingCarrusel producto="pvc_puertas_ventanas" initial={CARRUSEL_INICIAL} />
      </section>

      {/* Manual PDF */}
      <section className="max-w-6xl mx-auto px-4 pb-14 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">¡Somos Profesionales!</p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight">Garantía que se cuida <span style={{ color: AZUL }}>sola</span></h2>
          <p className="text-white/60 text-base mt-4">
            El PVC casi no pide mantenimiento, pero unos cuidados mínimos mantienen tu garantía cubierta y tus ventanas funcionando como el primer día.
          </p>
          <div className="bg-white/[0.04] border border-white/10 rounded-2xl p-5 mt-5" data-testid="guia-card">
            <p className="font-black text-sm">📘 Manual de Mantenimiento GRATIS</p>
            <p className="text-white/55 text-sm mt-1.5">
              Descarga nuestro manual con la limpieza correcta, el cuidado de rieles y herrajes, y los consejos para que tus puertas y ventanas duren décadas.
            </p>
            <a href={`${API}/api/landing/guia-pvc`} data-testid="guia-download-btn"
              className="inline-block mt-3 border border-[#1FA3E8] text-[#1FA3E8] hover:bg-[#1FA3E8] hover:text-white font-black px-5 py-2.5 rounded-full text-xs transition-colors">
              DESCARGAR PDF
            </a>
          </div>
        </div>
        <figure className="rounded-3xl overflow-hidden border border-white/10">
          <img src={IMG.banner} alt="Ventanería de PVC" className="w-full h-[380px] object-cover object-center" />
          <figcaption className="bg-black/60 text-xs text-white/70 px-4 py-2 font-bold">Ventanería de PVC: confort, silencio y cero mantenimiento</figcaption>
        </figure>
      </section>

      {/* Testimonios */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-testimonios">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Lo que dicen nuestros clientes</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Clientes que confiaron <span style={{ color: AZUL }}>en nosotros</span></h2>
        <LandingTestimonios producto="pvc_puertas_ventanas" initial={[
            {
              nombre: 'Familia Castellanos',
              texto: 'Cambiamos todas las ventanas de la casa a PVC blanco con vidrio insulado de cámara. La diferencia en el calor de la tarde es enorme y ya no se oye el tráfico de la calle. Además quedaron preciosas.',
            },
            {
              nombre: 'Arq. Lucía Mendoza',
              texto: 'Especifiqué la línea de PVC imitación madera para una residencia en Xela y el acabado sorprendió al cliente: se ve como madera real pero sin el mantenimiento. La instalación fue impecable.',
            },
            {
              nombre: 'Sr. Byron Estrada',
              texto: 'Pedí puertas corredizas con cedazo para la terraza. El sistema corre suavecito, el cedazo no se nota y la atención de principio a fin fue de primera. Muy recomendados.',
            },
          ]} color={AZUL} />
      </section>

      {/* FAQ */}
      <section className="max-w-3xl mx-auto px-4 pb-14" data-testid="seccion-faq">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Resolvemos tus dudas</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Preguntas <span style={{ color: AZUL }}>frecuentes</span></h2>
        <div className="space-y-3">
          {[
            ['¿El PVC es resistente? ¿No se deforma con el sol?',
              'Sí es resistente. Trabajamos PVC importado de buena calidad con protección UV, fabricado e instalado bajo los estándares de calidad, servicio y garantía de Soluciones. No se oxida y no necesita pintura.'],
            ['¿Qué es mejor: PVC o aluminio?',
              'Depende de tu proyecto. El PVC casi no pide mantenimiento y combinado con vidrio insulado termoacústico logra gran aislamiento; el aluminio (nuestra Línea Euro) permite perfiles más esbeltos y vanos muy grandes. Te asesoramos gratis para elegir.'],
            ['¿Qué vidrios puedo combinar?',
              'Claro, bronce, gris y en algunos casos reflectivo. También ofrecemos vidrio insulado termoacústico (doble vidrio con cámara) para máximo aislamiento — disponible también en la Línea Euro.'],
            ['¿Puedo ponerle mosquitero (cedazo)?',
              'Sí. Todas las puertas y ventanas pueden llevar cedazo fijo, corredizo o abatible, según el tipo de abertura.'],
            ['¿Cómo empiezo mi proyecto?',
              'Llena el formulario de esta página o escríbenos al WhatsApp 5430-7807. Vamos, medimos, te cotizamos y coordinamos la instalación de principio a fin.'],
          ].map(([q, a], i) => (
            <details key={q} className="group bg-white/[0.04] border border-white/10 rounded-2xl overflow-hidden" data-testid={`faq-item-${i}`}>
              <summary className="flex items-center justify-between gap-4 cursor-pointer px-5 py-4 font-bold text-sm sm:text-base list-none [&::-webkit-details-marker]:hidden hover:bg-white/[0.03] transition-colors">
                {q}
                <span style={{ color: AZUL }} className="text-xl font-black shrink-0 group-open:rotate-45 transition-transform">+</span>
              </summary>
              <p className="px-5 pb-5 text-white/65 text-sm leading-relaxed">{a}</p>
            </details>
          ))}
        </div>
      </section>

      {/* Formulario */}
      <section id="cotizar" className="max-w-2xl mx-auto px-4 pb-16">
        <div className="bg-white/[0.05] border border-white/10 rounded-3xl p-6 sm:p-8">
          {done ? (
            <div className="text-center py-6" data-testid="lead-success">
              <p className="text-5xl mb-4">✅</p>
              <h3 className="text-2xl font-black">¡Recibido, {form.nombre.split(' ')[0]}!</h3>
              <p className="text-white/60 text-sm mt-2 mb-6">Un asesor te contactará muy pronto. Si quieres respuesta inmediata, continúa por WhatsApp:</p>
              <a href={done.wa_link} target="_blank" rel="noreferrer" data-testid="lead-wa-btn"
                className="inline-block bg-[#25D366] hover:brightness-110 text-white font-black px-8 py-3 rounded-full text-sm transition-all">
                💬 Continuar en WhatsApp
              </a>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-black">Cotiza tus puertas y ventanas de PVC <span style={{ color: AZUL }}>GRATIS</span></h2>
              <p className="text-white/50 text-sm mt-1 mb-6">Sin compromiso. Te contactamos por WhatsApp o llamada.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Tu nombre *</label>
                  <input value={form.nombre} onChange={set('nombre')} data-testid="lead-nombre" placeholder="Ej: Carlos Pérez"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Teléfono / WhatsApp *</label>
                  <input value={form.telefono} onChange={set('telefono')} data-testid="lead-telefono" placeholder="Ej: 5555 5555" inputMode="tel"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">¿En qué departamento estás? *</label>
                  <select value={form.departamento} onChange={set('departamento')} data-testid="lead-departamento" style={{ colorScheme: 'dark' }}
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors">
                    <option value="">Selecciona…</option>
                    {DEPARTAMENTOS.map((d) => <option key={d} value={d}>{d}</option>)}
                  </select>
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Detalles de tu proyecto</label>
                  <textarea value={form.detalles} onChange={set('detalles')} data-testid="lead-detalles" rows={3}
                    placeholder="Ej: 4 ventanas corredizas blancas con cedazo y 1 puerta corrediza…"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors resize-none" />
                </div>
                <button type="submit" disabled={sending} data-testid="lead-submit"
                  style={{ background: AZUL }}
                  className="w-full hover:brightness-110 disabled:opacity-60 text-white font-black py-3.5 rounded-xl text-sm transition-all">
                  {sending ? 'Enviando…' : 'QUIERO MI COTIZACIÓN GRATIS'}
                </button>
              </form>
            </>
          )}
        </div>
      </section>

      <footer className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        Soluciones Arquitectónicas · Modernizando ambientes · Grupo SACH · Guatemala · WhatsApp +502 5430 7807 · +18 años de experiencia
      </footer>

      <a href={waLink('¡Hola! Vi la página de puertas y ventanas de PVC y quiero una cotización 😊')}
        target="_blank" rel="noreferrer" data-testid="wa-float-btn" aria-label="WhatsApp"
        className="fixed bottom-5 right-5 z-50 bg-[#25D366] hover:scale-110 transition-transform w-14 h-14 rounded-full flex items-center justify-center shadow-2xl">
        <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.7 6L4 29l8.2-1.6c1.2.6 2.5.9 3.8.9 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 22c-1.2 0-2.4-.3-3.5-.8l-.6-.3-4.9 1 1-4.7-.3-.6C6.6 18.1 6 16.6 6 15 6 9.5 10.5 5 16 5s10 4.5 10 10-4.5 10-10 10zm5.5-7.5c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.4z"/></svg>
      </a>
    </div>
  );
}
